<template>
    <div id="app">
        <layout v-if="!showErrorPage"></layout>
        <error-404 v-if="code == 404 && showErrorPage"></error-404>
        <error-500 v-if="code == 500 && showErrorPage"></error-500>
        <error-503 v-if="code == 503 && showErrorPage"></error-503>
        <template>
            <footer>
                <cookie-law theme="dark-lime">
                    <div slot="message">
                        This website uses cookies to ensure you get the best experience on our website.
                        More details <a href="https://futuro.network/terms" target="_blank">HERE</a>.
                    </div>
                </cookie-law>
            </footer>
        </template>
    </div>
</template>

<script>
    import CookieLaw from 'vue-cookie-law'
    import Error404 from './components/errors/Error404.vue'
    import Error500 from './components/errors/Error500.vue'
    import Error503 from './components/errors/Error503.vue'
    import Layout from './components/layout/Layout.vue'

    export default {
        name: 'app',
        components: { CookieLaw, Error404, Error500, Error503, Layout },
        computed: {
            code () {
                return this.$store.getters.error.code
            },
            showErrorPage () {
                return this.$store.getters.error.status
            }
        },
        beforeCreate () {
            if (!this.$store.getters.error.redirect) {
                this.$store.commit('setError', {
                    status: false,
                    code: 0,
                    redirect: false
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/css/bootstrap-vue.css";
    @import "assets/css/bootstrap.css";
    @import "assets/css/materialdesignicons.min.css";
    @import "assets/scss/_colors.scss";

    @font-face {
        font-family: Lato;
        src: url('assets/fonts/Lato-Regular.ttf');
    }

    @font-face {
        font-family: Lato;
        src: url('assets/fonts/Lato-Light.ttf');
        font-weight: lighter;
    }

    @font-face {
        font-family: Lato;
        src: url('assets/fonts/Lato-Bold.ttf');
        font-weight: bold;
    }

    #app {
        font-family: Lato;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    p{
        font-size: 15px;
        color: $base2;
        margin: 0;
        font-weight: bold;

        strong{
            color: $base2;
        }
    }

    @media(max-width: 359px){
        p{
            font-size: 13px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue